import themeVariables from "@Theme/exportColor.module.scss";

export default ({ fill = themeVariables.neutral8, width = "6px", height = "6px" }) => (
  <svg width={width} height={height} viewBox="0 0 6 6" version="1.1" fill={fill}>
    <g strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-198.000000, -1639.000000)" fillRule="nonzero">
        <g transform="translate(0.000000, 1215.000000)">
          <g transform="translate(182.000000, 423.000000)">
            <path
              d="M21.8108049,3.53640568 L19.463652,1.19086601 C19.2075832,0.936377995 18.7940877,0.936377995 18.5380188,1.19086601 L16.190866,3.53640568 C15.936378,3.79247453 15.936378,4.20597003 16.190866,4.46203888 L18.5380188,6.80886908 C18.7939419,7.06371031 19.207729,7.06371031 19.463652,6.80886908 L21.8108049,4.46203888 C22.0652929,4.20597003 22.0652929,3.79247453 21.8108049,3.53640568 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
